import { render, staticRenderFns } from "./ListaAtividadeDisciplinaDireito.vue?vue&type=template&id=2a650d57"
import script from "./ListaAtividadeDisciplinaDireito.vue?vue&type=script&lang=js"
export * from "./ListaAtividadeDisciplinaDireito.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports